(function() {
  // Estimates in base 2, 4, 6, ... etc.
  const estimates = [
    1, 2, 2, 1.06667, 1.14286, 1.82857E-01, 4.84848E-01, 4.54656E-02, 1.84958E-02, 7.42903E-03, 6.09669E-02, 9.47666E-05, 1.96912E-02, 2.21451E-04, 1.23807E-05, 1.02447E-05, 1.85352E-03, 2.59171E-08, 5.48833E-04, 1.49635E-08, 1.63840E-08, 1.30350E-07, 4.58481E-05, 8.98777E-13, 4.49969E-08, 2.82667E-09, 6.65775E-12, 1.85651E-12, 1.01777E-06, 3.22105E-17, 2.81454E-07, 4.87940E-14, 1.77782E-14, 1.17053E-12, 3.92241E-14, 5.67248E-22, 5.74587E-09, 2.27828E-14, 1.62035E-17, 1.57458E-21, 4.19321E-10, 4.96407E-25, 1.12642E-10, 1.90636E-20, 7.30658E-26, 8.11746E-18, 8.05104E-12, 1.51701E-30, 1.96999E-16, 5.35832E-25, 1.15448E-23, 1.71336E-24, 1.50778E-13, 9.17362E-34, 7.72083E-23, 2.80518E-30, 9.23183E-27, 4.90323E-23, 2.76909E-15, 4.22533E-43, 7.27923E-16, 8.74582E-25, 1.41365E-36, 7.57571E-32, 3.07903E-27, 6.81704E-41, 1.30998E-17, 1.20004E-32, 5.47721E-33, 6.86231E-41, 8.93425E-19, 1.15510E-51, 2.32894E-19, 4.74170E-30, 1.51911E-44, 9.54411E-37, 5.25134E-31, 6.77774E-49, 4.09832E-21, 2.35593E-49, 2.11935E-44, 1.41982E-33, 2.75907E-22, 5.98207E-61, 4.29160E-36, 2.43895E-35, 2.19409E-42, 6.88023E-48, 4.78832E-24, 1.50238E-68, 1.11628E-36, 5.62069E-45, 1.57654E-45, 7.10759E-39, 1.52726E-40, 4.17630E-68, 2.12896E-26, 2.45742E-49, 3.80206E-58, 3.46099E-61
  ]

  const composites = [true, true]

  for (const factor of [2, 3, 5, 7]) {
    for (let composite = factor * 2; composite <= estimates.length; composite += factor) {
      composites[composite] = true
    }
  }

  const chart = getEl('chart')

  let currentSelection = null
  let chartSize = null

  const legendSelected = getEl('legend-selected')
  const selectedBase = getEl('selected-base')
  const selectedE = getEl('selected-e')

  updateSize()

  window.addEventListener('resize', () => {
    updateSize()
  })

  setSelection(null)

  // TODO: Lots of this is just copy/paste from the other chart
  const fullButton = getEl('full-button')
  const chartWrapper = getEl('chart-wrapper')

  fullButton.addEventListener('click', () => {
    if (chartWrapper.className.includes('full-page')) {
      exitFullPage()
    } else {
      chartWrapper.className += ' full-page'
      updateSize()
    }
  })

  document.addEventListener('keydown', ev => {
    if (ev.keyCode === 27) {
      exitFullPage()
    }
  })

  function exitFullPage() {
    chartWrapper.className = chartWrapper.className.split(/\s+/).filter(cls => cls && cls !== 'full-page').join(' ')
    updateSize()
  }

  function updateSize() {
    const { width, height } = chart.getBoundingClientRect()
    const margin = Math.ceil(width * 0.025)

    chart.setAttribute('viewBox', `${-margin} ${-margin} ${width} ${height}`)

    chartSize = {
      height: height - 2 * margin,
      width: width - 2 * margin
    }

    updateChart()
  }

  function updateChart() {
    chart.innerHTML = ''

    chart.appendChild(createElement('line', {
      class: 'axes',
      x1: 0,
      x2: 0,
      y1: 0,
      y2: chartSize.height
    }))

    const min = Math.min(...estimates)
    const max = Math.max(...estimates)
    const logMin = Math.log10(min)
    const logMax = Math.log10(max)
    const logRange = logMax - logMin
    const maxBase = estimates.length * 2

    const horizontalLines = createElement('g')

    chart.appendChild(horizontalLines)

    for (let power = Math.ceil(logMin); power < logMax; ++power) {
      const y = Math.floor((1 - (power - logMin) / logRange) * chartSize.height) + 0.5

      horizontalLines.appendChild(createElement('line', {
        class: 'horizontal-line',
        x1: 0,
        x2: chartSize.width,
        y1: y,
        y2: y
      }))
    }

    const semiPrimeBestFit = []

    for (let base = 2; base <= maxBase; ++base) {
      const x = base / maxBase
      const estimate = Math.sqrt(Math.PI * (base ** 3) / 2 ** (base + 1))
      const y = 1 - (Math.log10(estimate) - logMin) / logRange

      semiPrimeBestFit.push(`${(x * chartSize.width).toFixed(1)} ${(y * chartSize.height).toFixed(1)}`)
    }

    chart.appendChild(createElement('polyline', {
      class: 'best-fit-line',
      points: semiPrimeBestFit.join(',')
    }))

    const points = createElement('g')
    const regions = createElement('g')

    chart.appendChild(points)
    chart.appendChild(regions)

    const regionWidth = chartSize.width / (estimates.length - 1)

    for (let index = 0; index < estimates.length; ++index) {
      const base = (index + 1) * 2
      const estimate = estimates[index]
      const logEstimate = Math.log10(estimate)

      const x = base / maxBase
      const y = 1 - (logEstimate - logMin) / logRange

      points.appendChild(createElement('circle', {
        class: 'point' + (composites[base / 2] ? '' : ' point-semi-prime'),
        cx: x * chartSize.width,
        cy: y * chartSize.height,
        r: 4
      }))

      const region = createElement('rect', {
        class: 'chart-region',
        dataIndex: index,
        height: chartSize.height + 8,
        width: Math.ceil(regionWidth),
        x: Math.round(x * chartSize.width - regionWidth / 2),
        y: -4,
      })

      region.addEventListener('click', () => {
        setSelection(region === currentSelection ? null : region)
      })

      regions.appendChild(region)
    }
  }

  function createElement(tag, attributes) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag)

    for (const name in attributes) {
      el.setAttribute(name.replace(/([A-Z])/g, '-$1').toLowerCase(), String(attributes[name]))
    }

    return el
  }

  function setSelection(selection) {
    if (currentSelection) {
      currentSelection.setAttribute('class', 'chart-region')
      currentSelection = null
    }

    let index = null

    if (selection != null) {
      currentSelection = selection
      currentSelection.setAttribute('class', 'chart-region selected')
      index = +selection.getAttribute('data-index')
    }

    if (index == null) {
      legendSelected.style.display = 'none'
      return
    }

    legendSelected.style.display = 'block'

    selectedBase.innerHTML = (index + 1) * 2
    selectedE.innerHTML = format(estimates[index])

    function format (num) {
      if (num === Math.round(num)) {
        return num
      }

      let multiplier = 1

      for (let dp = 1; dp <= 4; ++dp) {
        if (num * multiplier >= 10) {
          return num.toFixed(dp)
        }

        multiplier *= 10
      }

      let exp = 3

      while (num * (10 ** exp) < 1) {
        exp += 1
      }

      return (num * (10 ** exp)).toFixed(2) + 'e-' + exp
    }
  }

  function getEl(cls) {
    return document.querySelector('#demo-2 .' + cls)
  }
})()
